// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"j4-z","colorTextValue":"k4-z","swatches":"l4-z","collapseLink":"m4-z","isCollapsed":"n4-z","dropdown":"o4-z","disabled":"p4-z"};